<div #map id="nodeDetailsMap" class="node-detail-google-map"></div>
@if (loading) {
  <div class="spinner-outer">
    <div class="spinner-cover">
      <div class="spinner-section">
        <mat-progress-spinner [color]="spinnerColor" [diameter]="spinnerDiameter" [mode]="spinnerMode"
        [strokeWidth]="spinnerStrokeWidth" [value]="spinnerValue"></mat-progress-spinner>
      </div>
    </div>
  </div>
}